<template>
  <div>
    <h2>Selected User: {{ oktaUser.profile.firstName }} {{ oktaUser.profile.lastName }} - {{ oktaUser.profile.login }}</h2>
    <router-link :to="{ path: '/users', query: { login : oktaUser.profile.login }}" tag="button"><v-btn color="primary">Manage UserGroups</v-btn></router-link>
    <v-tabs
      slot="extension"
      v-model="selectedTab"
      centered
      color="secondary"
      slider-color="orange"
    >
      <v-tab href="#tabCurrent">
        Current
      </v-tab>
      <v-tab href="#tabHistory">
        History
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="selectedTab">
      <v-tab-item id="tabCurrent">
        <v-form ref="form">
          <v-layout row justify-center>
            <v-flex xs12 sm2>
              <okta-group-select @change="selectedAddGroup = $event.id" />
            </v-flex>
            <v-flex xs12 sm1>
              <v-btn
                tooltip.hover title="Add OKTA group (role)"
                fab
                dark
                color="primary"
                @click.native="addGroup"
              >
                <v-icon dark>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
        <v-data-table
          :headers="tableHeadersCurrent"
          :items="oktaUser.groups"
          class="elevation-1"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item="props">
            <tr>
              <td class="justify-center">
                <v-btn tooltip.hover title="Inactivate OKTA group (role)" icon class="mx-0" @click="showDelete = true; selectedDeleteGroup = props.item">
                  <v-icon color="primary">delete</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.value }}</td>
            </tr>
          </template>
        </v-data-table>
        <v-dialog
          v-model="showDelete"
          persistent
          max-width="500px"
        >
          <v-card>
            <v-card-title>
              <h3>Remove Group from User</h3>
            </v-card-title>
            <v-card-text>
              <p>
                You have chosen to remove access to the User Group <strong>{{ selectedDeleteGroup.value }}</strong> for the user <strong>{{ oktaUser.profile.login }}</strong>.
                Please confirm that this user should no longer have access to this group by clicking the <strong class="yes-remove-button">Yes, Remove button</strong>.
              </p>
              <p>If you clicked Remove by mistake, click the <strong class="no-remove-button">No, Don't Remove button</strong> and you will be returned to your task.</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="error" @click.stop="showDelete = false">No, Don't Remove</v-btn>
              <v-btn color="primary" @click.stop="deleteGroup()">Yes, Remove</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-tab-item>
      <v-tab-item id="tabHistory">
        <v-data-table
          :headers="tableHeadersHistory"
          :items="oktaUserHistoryC"
          class="elevation-1"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item="props">
            <tr>
              <td :class="props.item.action === 'add' ? 'add-text-color' : 'remove-text-color'">
                {{ props.item.action === 'add' ? 'Add' : 'Remove' }}
              </td>
              <td>{{ props.item.groupName }}</td>
              <td>{{ props.item.createdBy }}</td>
              <td>{{ props.item.createdOn | formatDate }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import OktaGroupSelect from '@/components/manageOktaUsers/OktaGroupSelect'
export default {
  name: 'manage-okta-users-table',
  components: {
    OktaGroupSelect
  },
  props: {
    oktaUser: Object
  },
  data: () => ({
    tableHeadersCurrent: [
      {
        text: 'Actions',
        value: false,
        sortable: false
      },
      {
        text: 'Okta Group (role)',
        value: 'value'
      }
    ],
    tableHeadersHistory: [
      {
        text: 'Action',
        value: 'action'
      },
      {
        text: 'Group',
        value: 'groupName'
      },
      {
        text: 'Changed By',
        value: 'createdBy'
      },
      {
        text: 'Changed On',
        value: 'createdOn'
      }
    ],
    showDelete: false,
    selectedDeleteGroup: {},
    selectedAddGroup: '',
    selectedTab: 'tabCurrent'
  }),
  computed: {
    ...mapState('oktaUsers', ['oktaUserHistory']),
    ...mapGetters('oktaGroups', ['groupName']),
    oktaUserHistoryC: function() {
      this.oktaUserHistory.forEach(entry => {
        entry.groupName = this.groupName(entry.groupId)
      })
      return this.oktaUserHistory
    }
  },
  created() {
    this.getOktaUserHistory(this.oktaUser.id)
  },
  methods: {
    ...mapActions('oktaUsers', ['deleteOktaUsersGroup', 'addOktaUsersGroup', 'getOktaUserHistory']),
    deleteGroup() {
      this.deleteOktaUsersGroup({ userId: this.oktaUser.id, groupId: this.selectedDeleteGroup.id })
      this.showDelete = false
    },
    addGroup() {
      if (this.$refs.form.validate()) {
        this.addOktaUsersGroup({ userId: this.oktaUser.id, groupId: this.selectedAddGroup })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .add-text-color {
    color: $color-success;
  }

  .remove-text-color {
    color: $color-danger
  }

  .yes-remove-button {
    color: $color-primary;
  }

  .no-remove-button {
    color: $color-danger;
  }
</style>
